module.exports = __webpack_public_path__ + "static/media/profile_pic.a7c50753.jpeg";